import AbstractIceContentController from '../../abstract/ice-content/controller';

const HELPERS = window.App.Utils.Helpers;
const defaultModalID = 'modal-message';
const defaultModalButtonID = 'cards-modal__button-for-ice__modal-message';
class Controller extends AbstractIceContentController {
    constructor(widget) {
        super(widget);
        this.init(widget);
    }

    init(widget) {
        if (b$.portal.loggedInUserGroup.length === 0) {
            HELPERS.confirmOnLeave();

            let successPage = decodeURI(widget.getPreference('successPage'));
            const errorPage = decodeURI(widget.getPreference('errorPage'));
            const errorTransactionPage = decodeURI(widget.getPreference('errorTransactionPage'));
            const propertyToCheck = decodeURI(widget.getPreference('propertyToCheck'));
            const encryptionEndpoint = HELPERS.adaptEnvironment(decodeURI(widget.getPreference('apiEndpoint')), true);
            const encryptionHeadersPref = decodeURI(widget.getPreference('encryptionHeaders'));
            const encryptionHeaders = JSON.parse(encryptionHeadersPref);
            const errorModalData = {
                "content": "",
                "isIce": true,
                "size": "small",
                "disableScroll": true,
                "showCloseIcon": true,
                "showButton": true
            };
            const dataSchema = JSON.parse(decodeURI(widget.getPreference('dataSchema')));
            const dataInitialization = decodeURI(widget.getPreference('dataInitialization'));
            const dataInitializationName = decodeURI(widget.getPreference('dataInitializationName'));
            const notHttpResponse = JSON.parse(decodeURI(widget.getPreference('errorDetails')));
            const UTMParams = decodeURI(widget.getPreference('z_UTMparams'));
            const searchParams = new URLSearchParams(window.location.search);
            const customerToken = searchParams.get('ct');

            if(customerToken && customerToken.length > 0) {
                //Remove ct (customerToken) on the url params so it will not be included when forwarding the urlParams to the successPage
                history.replaceState && history.replaceState(
                    null, '', location.pathname + location.search.replace(/[\?&]ct=[^&]+/, '').replace(/^&/, '?')
                );
            }

            const windowLocation = window.location.href;
            const urlParams = windowLocation.split('?')[1];

            if(urlParams) {
                successPage = `${successPage}?${urlParams}`;
            }

            HELPERS.removeFromStorage();
            sessionStorage.removeItem('integrationData');
            sessionStorage.removeItem('httpResponse');
            HELPERS.deleteCookie('BBXSRF');

            function tryAgain() {
                App.PubSub.publish(defaultModalID, errorModalData);
                document.getElementById(defaultModalButtonID).onclick = function () {
                    authenticateUser();
                    App.PubSub.publish(defaultModalID, "hide");
                }
            }

            if (navigator.onLine) {
                authenticateUser();
            } else {
                tryAgain();
            }

            function authenticateUser() {
                const xhr = new XMLHttpRequest();
                const endpoint = HELPERS.adaptEnvironment(decodeURI(widget.getPreference('apiEndpoint')), false);
                const headers = decodeURI(widget.getPreference('oAuthHeaders'));
                const parsedHeaders = JSON.parse(headers);

                if (customerToken) {
                    parsedHeaders.customerCCPQToken = customerToken;
                }

                xhr.open("GET", endpoint, true);
                xhr.withCredentials = true;
                xhr.setRequestHeader("Content-type", parsedHeaders["contentType"]);
                xhr.setRequestHeader("intSvcName", parsedHeaders["intSvcName"]);
                xhr.setRequestHeader("service", parsedHeaders["service"]);
                xhr.timeout = HELPERS.getApiRequestTimeout();
                xhr.ontimeout = function (e) {
                    tryAgain();
                }

                xhr.onreadystatechange = function () {
                    if (xhr.readyState === 4) {
                        let result = {};
                        try {
                            result = JSON.parse(xhr.response);
                        } catch (err) {
                            result = xhr.response;
                        }

                        if (xhr.status === 200) {
                            if (result && result.status === "success") {
                                const bbxsrfCookie = window.App.Utils.Object.getJourneyCookie("BBXSRF");
                                getAPICall(customerToken, bbxsrfCookie); //Continue with submission
                            } else {
                                App.PubSub.publish("redirectToErrorPage", {
                                    status: 400, //if 200, gets redirected to error page with Service Temporarily Unavailable
                                    code: notHttpResponse.error_code,
                                    body: notHttpResponse,
                                    errorPage: `/${HELPERS.getRelativePath()}${errorPage}`,
                                    withIcon: false
                                });
                            }
                        } else {
                            App.PubSub.publish("redirectToErrorPage", {
                                status: xhr.status,
                                code: result.error_code,
                                body: result,
                                errorPage: `/${HELPERS.getRelativePath()}${errorPage}`,
                                withIcon: false
                            });
                        }
                    }
                };
                return xhr.send(null);
            }

            function getAPICall(customerToken, bbxsrfCookie) {
                let body = {
                    customerCCPQToken: customerToken
                };

                const xhr = new XMLHttpRequest();
                const endpoint = HELPERS.adaptEnvironment(decodeURI(widget.getPreference('apiEndpoint')), false);
                const headers = decodeURI(widget.getPreference('pullHeaders'));
                const parsedHeaders = JSON.parse(headers);

                body = getUTMParams(body);

                xhr.open("POST", endpoint, true);
                xhr.withCredentials = true;
                xhr.setRequestHeader("Content-type", parsedHeaders["contentType"]);
                xhr.setRequestHeader("intSvcName", parsedHeaders["intSvcName"]);
                xhr.setRequestHeader("service", parsedHeaders["service"]);
                xhr.setRequestHeader("X-BBXSRF", bbxsrfCookie);
                xhr.timeout = HELPERS.getApiRequestTimeout();
                xhr.ontimeout = function (e) {
                    tryAgain();
                };
                xhr.onreadystatechange = function () {
                    if (xhr.readyState === 4) {
                        let result = {};

                        try {
                            result = JSON.parse(xhr.response);
                        } catch (err) {
                            result = xhr.response;
                        }

                        if (xhr.status === 200 && result && result.status === "success") {

                            checkResult(result, bbxsrfCookie, propertyToCheck, errorTransactionPage);

                        } else if ((xhr.status === 200 || xhr.status === 400) && (!result || (!result.status && !result.error_code))) {

                            App.PubSub.publish("redirectToErrorPage", {
                                status: 400,
                                code: notHttpResponse.error_code,
                                body: notHttpResponse,
                                errorPage: `/${HELPERS.getRelativePath()}${errorPage}`,
                                withIcon: false
                            });
                        } else {

                            App.PubSub.publish("redirectToErrorPage", {
                                status: xhr.status,
                                code: result.error_code,
                                body: result,
                                errorPage: `/${HELPERS.getRelativePath()}${errorPage}`,
                                withIcon: false
                            });
                        }
                    }
                };
                return xhr.send(JSON.stringify(body));
            }

            function getUTMParams(body) {
                UTMParams.split(',').forEach(function (utm) {
                    const utmFound = searchParams.get(utm.trim());
                    if (utmFound && utmFound.length !== 0) {
                        body[utm.replace(/_([a-z])/g, function (g) {
                            return g[1].toUpperCase();
                        })] = utmFound;
                    } else {
                        console.log(`missing UTM parameter: ${utm}`);
                    }
                });
                return body;
            }

            //Initialize data to save to sessionStorage: ex. otpSummary
            function initDataInStorage(parsedDataStructure) {
                if (dataInitialization.length > 0 && dataInitializationName.length > 0) {
                    const dataInit = {};
                    const parsedDataInit = JSON.parse(dataInitialization);
                    const dataInitTarget = Object.assign({}, parsedDataInit, parsedDataStructure);
                    dataInit.body = dataInitTarget;

                    App.PubSub.subscribe("initializeInStorage", function (encryptedData) {
                        sessionStorage.setItem(dataInitializationName, encryptedData);
                        HELPERS.goToPage(`/${HELPERS.getRelativePath()}${successPage}`);
                    });

                    HELPERS.encryptDecrypt(dataInit, encryptionEndpoint, encryptionHeaders, true, errorPage, "initializeInStorage");
                }
            }

            function checkResult(result, bbxsrfCookie, propertyToCheck, redirectPage) {
                if (result.status === "success") {
                    const parsedDataStructure = App.Utils.Object.transformMapData(result, dataSchema);
                    initDataInStorage(parsedDataStructure); //Continue with Backend Encryption

                    if (redirectPage.length > 0) {
                        if (bbxsrfCookie === null || !result.body || !result.body.hasOwnProperty(propertyToCheck) || result.body[propertyToCheck].length === 0) {
                            HELPERS.goToPage(`/${HELPERS.getRelativePath()}${redirectPage}`);
                        }
                    }
                } else {
                    const notHttpResponse = {
                        status: result.status,
                        description: result.description,
                        message: result.message
                    };

                    sessionStorage.setItem('notHttpResponse', JSON.stringify(notHttpResponse));
                    HELPERS.goToPage(`/${HELPERS.getRelativePath()}${errorPage}`);
                }
            }
        }
    }
}
export default Controller;



// WEBPACK FOOTER //
// ./collection-institutional-portal/src/widgets/widget-loading/scripts/controller.js